import { useCallback } from "react";

import useFetchContract from "./use-fetch-contract";

export default function usePrefillsXero() {
  const {
    isLoading: useFetchContractIsLoading,
    error: useFetchContractError,
    get,
  } = useFetchContract();

  const getPrefill = useCallback(async () => {
    const res = (await get(`prefill/xero/contacts`)) as any;

    return res.data;
  }, [get]);

  return {
    isLoading: useFetchContractIsLoading,
    error: useFetchContractError,
    getPrefill,
  };
}
